export const getTabbableElements = (root: HTMLElement = document.body): HTMLElement[] => {
    const walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_ELEMENT,
        {
            acceptNode(node: Node) {
                const element = node as HTMLElement;
                const isDisabled = `disabled` in element && (element as HTMLInputElement | HTMLButtonElement).disabled;
                const isHidden = `hidden` in element && (element as HTMLElement & { hidden: boolean }).hidden;

                if (
                    element.tabIndex >= 0 &&
                    !isDisabled &&
                    !isHidden &&
                    element.offsetParent !== null
                ) {
                    return NodeFilter.FILTER_ACCEPT;
                }
                return NodeFilter.FILTER_SKIP;
            }
        }
    );

    const result: HTMLElement[] = [];
    let current = walker.nextNode() as HTMLElement | null;
    while (current) {
        result.push(current);
        current = walker.nextNode() as HTMLElement | null;
    }

    return result;
};

export const focusNext = (from: HTMLElement, backwards = false) => {
    const tabbables = getTabbableElements();
    const index = tabbables.indexOf(from);
    const next = tabbables[index + (backwards ? -1 : 1)];
    next?.focus();
};
